// START Change cart promo header for mobile
if($(window).width() < 568) {
   console.log($(window).width());
    $(".cart-promo-header-img").each(function() {
      
      $(this).attr("src", "https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_2025-free-ornament_cart-banner_mobile_600x300_v2.jpg?v=1761936854"); 
                });
            } else if ($(window).width() >= 568) {
                
                $(".cart-promo-header-img").each(function() {
                $(this).attr("src","https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_2025-free-ornament_cart-banner-desktop_1100x300_v2.jpg?v=1761936854");

                });                        
    };
// END Change logo for mobile